import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedReorder202602: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_reorder_202602",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-02-01",
  endDate: "2026-02-28",
  impressions: 12480,
  clicks: 248,
  adsSpendDollars: 621,
  budgetDollars: 900,
  salesDollars: 8294,
  bestEstimateRoas: 13.36,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.69,
  reorderConversions: 28,
  dataAvailableAtDate: "2026-03-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
